import { useState } from 'react';

import './Options.css'
import { countries } from './countries/countries'
import Spinner from '../spinner/spinner';

const OrderBusiness = () => {
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        companyName: '',
        street: '',
        zip: '',
        city: '',
        country: 'Deutschland'
    });
    const [agbCheck, setAgbCheck] = useState(false);
    const [agbError, setAgbError] = useState(false);
    const [errorBestellung, setErrorBestellung] = useState(false);
    const [showOrderSuccess, setShowOrderSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleOrder = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (agbCheck) {
            try {
                const res = await fetch('/api/v1/order-business', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': process.env.REACT_APP_SPIRII_CHARGING_CARD_API_KEY
                    },
                    body: JSON.stringify(userData)
                });

                if (res.status === 201) {
                    setShowOrderSuccess(true)
                } else {
                    setIsLoading(false);
                    setErrorBestellung(true);
                }
            } catch (error) {
                console.error('Error:', error);
                setIsLoading(false);
                setErrorBestellung(true);
            }
        } else {
            setAgbError(true);
        }
        setIsLoading(false);
    };


    if (isLoading) {
        return (
            <div className="App container-fluid bg-appBackground py-12 py-auto h-full min-h-screen text-center">
                <Spinner />
            </div>
        )
    }

    function handleChangeCheckboxAgb(event) {
        if (event.target.checked) {
            setAgbCheck(true);
            setAgbError(false);
        } else {
            setAgbCheck(false);
        }

    }

    return (
        <div>
            {!showOrderSuccess ? (
                <div>
                    <form onSubmit={(event) => handleOrder(event)}>
                        <div className='expand'>
                            <div className="mb-6">
                                <input type="text" id="name" name="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md" placeholder="Name *" required onChange={(event) => setUserData({ ...userData, name: event.target.value })} />
                            </div>
                            <div className="mb-6">
                                <input type="email" id="email" name="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md" placeholder="E-Mail *" required onChange={(event) => setUserData({ ...userData, email: event.target.value })} />
                            </div>
                            <div className="mb-6">
                                <input type="text" id="firmenname" name="firmenname" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md" placeholder="Firmenname (optional)" onChange={(event) => setUserData({ ...userData, companyName: event.target.value })} />
                            </div>
                            <div className="mb-6">
                                <input type="text" id="strasseNum" name="strasseNum" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md" placeholder="Straße und Nr.*" required onChange={(event) => setUserData({ ...userData, street: event.target.value })} />
                            </div>
                            <div className="mb-6">
                                <input type="text" id="plz" name="plz" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md" placeholder="PLZ *" required onChange={(event) => setUserData({ ...userData, zip: event.target.value })} />
                            </div>
                            <div className="mb-6">
                                <input type="text" id="ort" name="ort" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md" placeholder="Ort *" required onChange={(event) => setUserData({ ...userData, city: event.target.value })} />
                            </div>
                            <div className="mb-6">
                                <select
                                    id="countries"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm hover:border-primary focus:border-primary focus:ring-transparent custom-transition block p-2 w-full mx-auto font-avenir text-md"
                                    onChange={(event) =>
                                        setUserData({
                                            ...userData,
                                            country: countries[event.target.value].de, // Standard auf Deutsch
                                        })
                                    }
                                >
                                    <option value="DE" defaultValue>{countries["DE"].de}</option>
                                    {Object.entries(countries)
                                        .filter(([key]) => key !== "DE")
                                        .map(([key, value], index) => (
                                            <option value={key} key={index}>{value.de}</option>
                                        ))}
                                </select>
                            </div>

                        </div>
                        <div className="flex items-center my-3">
                            <input id="agb" type="checkbox" required value="" className="w-6 h-6 text-appBackground ring-primary ring-1 focus:border-primary bg-appBackground border-primary focus:ring-primary focus:ring-1 accent-appBackground" onChange={(event) => handleChangeCheckboxAgb(event)} />
                            <label htmlFor="agb" className="ml-2 text-md font-medium text-white font-avenir">Ich erkläre mich mit den <a target="_blank" rel="noreferrer" href="https://www.connect-gp-joule.de/service/anb-connect-charge/" className="text-primary text-lg hover:underline">ANB</a> einverstanden.</label>
                        </div>
                        <button type="submit" className="w-full bg-primary text-black py-2 font-avenir custom-transition hover:shadow-primary-outline">Jetzt bestellen</button>
                    </form>
                    {errorBestellung && <p className='text-red-600'>Oops, es ist ein Fehler bei der Bestellung aufgetreten! Wenden Sie sich mit Ihrem Anliegen per E-Mail an service.connect@gp-joule.de. Unser Kundenservice wird Ihnen schnellstmöglich helfen.</p>}
                    {agbError && <p className='text-red-600'>Bitte erklären Sie sich mit den ANB einverstanden.</p>}
                </div>
            ) : (
                <div>
                    <h3 className="text-primary text-left font-avenir font-extrabold text-xl mt-10">Vielen Dank für Ihren Auftrag.</h3>
                    <p className="text-white text-left font-avenir">Wir werden Ihre Bestellung umgehend bearbeiten und Ihnen die GP JOULE CONNECT Ladekarte postalisch zusenden.</p>
                </div>
            )}
        </div>
    )
}

export default OrderBusiness;